module.exports = __webpack_public_path__ + "static/images/scheduling.32s0TKH.svg";